import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function updateMtrSpec(id, payload) {
  const { data: raw } = await request.patch(`/mtr-spec/${id}`, keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
